export enum RoutePaths {
  SIGN_UP = '/signup',
  SIGN_IN = '/login',
  RESET_PASSWORD = '/reset',
  VERIFY = '/verify',
  UPDATE_PASSWORD = '/update_password',
}
